export default "__VITE_PUBLIC_ASSET__6f969e28__"